import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import OrderService from "../services/PosService/OrderService";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import UtilsFormule from "../utils/UtilsFormule";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { Modal, Form } from "react-bootstrap";
import toastr from "toastr";

import { Alert, Snackbar, Dialog, DialogActions, DialogContent, DialogContentText, TextField, DialogTitle, Button } from "@mui/material";
const DataTableTicketShop = ({ tickets }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // const [tickets, setTickets] = useState(availableTicket);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [reference, setReference] = useState("");
  const [enteredReference, setEnteredReference] = useState("");
  const [selectedReference, setSelectedReference] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const { SearchBar } = Search;
  const [newCreationDate, setNewCreationDate] = useState("");
  const [showModal, setShowModal] = useState(false);

  // Handle delete modal open/close
  const handleOpenDeleteModal = (row) => {
    setSelectedRow(row);
    setOpenDeleteModal(true);
    setReference(row.reference);
    console.log("setReference", row.reference)
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setSelectedRow(null);
  };
  // Handle the delete action
  const handleDelete = async () => {
    if (enteredReference === reference) {
      try {
        // Add your delete logic here
        console.log("Deleting row:", selectedRow);

        // Await the delete operation
        await OrderService.removeTicketsCaisses(getCurrentUserId(), reference);

        // Close the delete modal
        handleCloseDeleteModal();

        // Show a success toast
        toast.success("Item deleted successfully!");
      } catch (error) {
        // Handle errors
        console.error("Error deleting item:", error);
        toast.error("Failed to delete item. Please try again.");
      }
    }
  };

    const handleOpenModal = (reference, creationDate) => {
    setSelectedReference(reference);
    const date = new Date(creationDate);
    const formattedDate = date.toISOString().replace('T', ' ').slice(0, 19).replace(/ /g, 'T');
    setNewCreationDate(formattedDate);
    setShowModal(true);
  };

  function buttonDeleteFormatter(cell, row) {
    return (
 <div style={{ display: 'flex', gap: '8px' }}>        
 <button
           style={{ width: 40 }}

          className="btn btn-danger"
          onClick={() => handleOpenDeleteModal(row)}
        >
          <h6>
            <small>
              <i className="fas fa-trash"></i>
            </small>
          </h6>
        </button>
     <button
          style={{ width: 40 }}
          className="btn btn-warning btn-sm"
          onClick={() => {
            console.log("row-------------------------------------->", row)
            handleOpenModal(row.reference, row.creationDate)
          }
          }
        >
          <i className="fas fa-edit"></i>
        </button>
      </div>
    );
  }
  // const MyExportCSV = ({ csvProps }) => {
  //   const { data } = csvProps || {};
  //   if (!data || data.length === 0) {
  //     return <div>No data available for export.</div>;
  //   }

  //   return (
  //     <div>
  //       <button
  //         className="btn btn-dark"
  //         onClick={() => handleExportExcel(data)}
  //       >
  //         <i className="fas fa-download"></i> Télécharger CSV
  //       </button>
  //     </div>
  //   );
  // };
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  function PriceFormatter(cell, row) {
    if (cell === null || cell === "") {
      return <span>-</span>;
    } else {
      return <span>{cell} TND</span>;
    }
  }
  function PayedFormatter(cell, row) {
    if (cell === 0 && row?.restToPay === row?.price) {
      return <span className="badge badge-danger">Non Payé</span>;
    } else if (cell === 0 && row?.restToPay !== row?.price) {
      return <span className="badge badge-warning">Payé Partiellement</span>;
    } else if (cell === 1) {
      return <span className="badge badge-success">Payé en totalité</span>;
    }
  }

  function DateFormatter(cell, row) {
    if (cell != null || cell != "") {
      return UtilsFormule.formatDate(cell);
    }
  }

  function AvrFormatter(cell, row) {
    if (row.referenceAvr != null || row.referenceAvr != "") {
      return row.referenceAvr;
    }else{
            return "pas d'avoir";

    }
  }
   function RssFormatter(cell, row) {
    if (row.referenceRss != null || row.referenceRss != "") {
      return row.referenceRss;
    }else{
            return "pas de rss";

    }
  }

  const columns = [
    {
      dataField: "reference",
      text: "#Référence",
      align: "center",
      headerAlign: "center",
    },
    {
      dataField: "priceBeforePromotion",
      text: "Prix Avant Promotion",
      align: "center",
      formatter: PriceFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "price",
      text: "Prix",
      align: "center",
      formatter: PriceFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "restToPay",
      text: "Reste à payer",
      align: "center",
      formatter: PriceFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "isPayed",
      text: "Est Payé",
      align: "center",
      formatter: PayedFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "creationDate",
      text: "CD",
      align: "center",
      formatter: DateFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
     {
      dataField: "reference",
      text: "Avoir",
      align: "center",
      formatter: AvrFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "reference",
      text: "RSS",
      align: "center",
      formatter: RssFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    // {
    //   dataField: "id",
    //   text: "Compléter",
    //   formatter: buttonFormatter,
    //   align: "center",
    //   headerAlign: "center",
    //   headerStyle: () => {
    //     return { width: "12%" };
    //   },
    // },
    {
      dataField: "id",
      text: "Actions",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
  ];



  function RefPayementFormatter(row) {
    if (row.typePayement === "Espéce") {
      return (
        <span>
          {row.ref}-{row.year}
        </span>
      );
    } else if (row.typePayement === "Virement") {
      return <span>{row.numVirement}</span>;
    } else if (row.typePayement === "Chéque / Traites") {
      return <span>{row.codeCheque}</span>;
    } else if (row.typePayement === "Prélevement") {
      return <span>Prélevement</span>;
    } else if (row.typePayement === "CarteCadeau") {
      return <span>Carte cadeau</span>;
    } else {
      return <span>En ligne</span>;
    }
  }
 const carteCadeauTicketInfo = (carteCadeauClient) => {
    return (
      <table
        className="table table-striped table-bordered table-sm"
        cellSpacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "15%" }}>Ref</th>
            <th style={{ width: "15%" }}>Libellé</th>
            <th style={{ width: "15%" }}>Montant</th>
          </tr>
        </thead>
        <tbody>
            <tr>
          
              <td className="text-center">{carteCadeauClient.ref || ""}</td>
              <td className="text-center">{carteCadeauClient?.carteCadeau?.name || ""}</td>
              {/* <td className="text-center">{product.sku || ""}</td> */}
              <td className="text-center">{carteCadeauClient?.carteCadeau?.value || ""}</td>
            </tr>
        
        </tbody>
      </table>
    );
  };
  const especeInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Espèce</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Espèce</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Espèce</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Espèce</td>
              <td>
                {row.ref}-{row.year}
              </td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>

              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const enLigneInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>En ligne</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>En ligne</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>En ligne</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>En ligne</td>
              <td>
                {row.ref}-{row.year}
              </td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>

              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const virementInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Virement</td>
                <td>{row.numVirement}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Virement</td>
                <td>{row.numVirement}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Virement</td>
                <td>{row.numVirement}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Virement</td>
              <td>{row.numVirement}</td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>

              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const chequeInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref.Cheque</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref.Cheque</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Chèque/ traites</td>
                <td>{row.codeCheque}</td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref.Cheque</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>Date echeance</th>

              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Chèque/ traites</td>
              <td>{row.codeCheque}</td>

              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
              <td>{UtilsFormule.formatDateHours(row.echeanceDate)} </td>

              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const prelevementInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Prélevement</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Prélevement</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Prélevement</td>
                <td>
                  {row.ref}-{row.year}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Prélevement</td>
              <td>
                {row.ref}-{row.year}
              </td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };

  const carteCadeauInfo = (row) => {
    if (row.typePayementValidation === "accept") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>

                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Ref.Opération</th>
                <th style={{ width: "15%" }}>Date Opération</th>
                <th style={{ width: "15%" }}>Date Valeur</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Accepté</td>
                <td>Carte cadeau</td>
                <td>
                  {row.ref}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">{row.refOperation} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.valeurDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Refus</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Rejeté</td>
                <td>Carte cadeau</td>
                <td>
                  {row.ref}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.rejectDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else if (row.typePayementValidation === "refuse-def") {
      return (
        <>
          {row.descriptionOperation !== null && (
            <p>{row.descriptionOperation}</p>
          )}
          <table
            class="table table-striped table-bordered table-sm"
            cellspacing="0"
            width="100%"
          >
            <thead>
              <tr className="text-center">
                <th style={{ width: "15%" }}>Payement</th>
                <th style={{ width: "15%" }}>Type payement</th>
                <th style={{ width: "15%" }}>Ref</th>
                <th style={{ width: "15%" }}>DC</th>
                <th style={{ width: "15%" }}>M.Payé</th>
                <th style={{ width: "15%" }}>Date Opération</th>
              </tr>
            </thead>
            <tbody>
              <tr key={row.idPayementInfo}>
                <td>Refusé définitivement</td>
                <td>Carte cadeau</td>                <td>
                  {row.ref}
                </td>
                <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
                <td className="text-center">{row.amountPayed} </td>
                <td className="text-center">
                  {UtilsFormule.formatDateHours(row.operationDate)}{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </>
      );
    } else {
      return (
        <table
          class="table table-striped table-bordered table-sm"
          cellspacing="0"
          width="100%"
        >
          <thead>
            <tr className="text-center">
              <th style={{ width: "15%" }}>Type payement</th>
              <th style={{ width: "15%" }}>Ref</th>
              <th style={{ width: "15%" }}>DC</th>
              <th style={{ width: "15%" }}>M.Payé</th>
            </tr>
          </thead>
          <tbody>
            <tr key={row.idPayementInfo}>
              <td>Carte cadeau</td>
              <td>
                {row.ref}
              </td>
              <td>{UtilsFormule.formatDateHours(row.creationDate)} </td>
              <td className="text-center">{row.amountPayed} </td>
            </tr>
          </tbody>
        </table>
      );
    }
  };
  const productsTicketInfo = (products) => {
    return (
      <table
        className="table table-striped table-bordered table-sm"
        cellSpacing="0"
        width="100%"
      >
        <thead>
          <tr className="text-center">
            <th style={{ width: "15%" }}>Code produit</th>
            <th style={{ width: "15%" }}>Code à barre</th>
            <th>Produit</th>
            {/* <th style={{ width: "15%" }}>SKU</th> */}
            <th style={{ width: "15%" }}>Quantité</th>
            <th style={{ width: "15%" }}>Prix de vente</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product, index) => (
            <tr key={index}>
              {/* <td>
                {product.barcode || ""} - {product.name || ""}
              </td> */}
              <td className="text-center">{product.productCode || ""}</td>
              <td className="text-center">{product.barcode || ""}</td>
              <td>{product.name || ""}</td>
              {/* <td className="text-center">{product.sku || ""}</td> */}
              <td className="text-center">{product.quantity || ""}</td>
              <td className="text-center">{product.priceAfterDiscount || ""}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const expandRow = {
    renderer: (row) => (
      <>
        {row?.payementInformationList &&
          row.payementInformationList.length > 0 ? (
          <>
            <div
              className="text-center mt-2 mb-3"
              style={{ fontStyle: "italic" }}
            >
              <b> Informations de paiement </b>
            </div>
            {row.payementInformationList.map((item) => {
              switch (item?.typePayement) {
                case "Espéce":
                  return especeInfo(item);
                case "En ligne":
                  return enLigneInfo(item);
                case "Chéque / Traites":
                  return chequeInfo(item);
                case "Virement":
                  return virementInfo(item);
                case "Prélevement":
                  return prelevementInfo(item);
                  case "CarteCadeau":
                    return carteCadeauInfo(item);
                default:
                  return null;
              }
            })}
          </>
        ) : (
          <div
            className="text-center mt-2 mb-3"
            style={{ fontStyle: "italic" }}
          >
            <b> Informations de paiement </b> : Pas de payement !
          </div>
        )}
        <div className="text-center mt-2 mb-3" style={{ fontStyle: "italic" }}>
          <b> Liste des produits </b>
        </div>
              <div className="text-center mt-2 mb-3" style={{ fontStyle: "italic" }}>
          <b> Carte Cadeau </b>
        </div>
        {row?.carteCadeauClient && row?.carteCadeauClient != null
          ? carteCadeauTicketInfo(row.carteCadeauClient)
          : "Pas de carte cadeau !"}
        {row?.products && row?.products != null && row.products.length > 0
          ? productsTicketInfo(row.products)
          : "Pas de produits !"}
      </>
    ),
    showExpandColumn: true,
    expandHeaderColumnRenderer: ({ isAnyExpands }) => {
      if (isAnyExpands) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <b style={{ cursor: "pointer" }}>-</b>;
      }
      return <b style={{ cursor: "pointer" }}>+</b>;
    },
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ tickets }) {
    return tickets;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  const handleExportExcel = ({ dataToExport }) => {
    const headers = [
      { key: "Reference", text: "Référence" },
      { key: "priceBeforePromotion", text: "Prix Avant Promotion" },
      { key: "Prix", text: "Prix" },
      { key: "isPayed", text: "Est Payé" },
    ];

    // Check if tickets exist and have data
    if (!tickets || tickets.length === 0) {
      toast.error("No data to export.");
      return;
    }

    // Use all tickets if dataToExport is undefined or empty
    const dataToExportFinal =
      dataToExport && dataToExport?.length > 0 ? dataToExport : tickets;

    // Format data for export
    const data = dataToExportFinal.map((item) => ({
      Reference: item.reference,
      priceBeforePromotion: item.priceBeforePromotion,
      Prix: item.price,
      isPayed:
        item.isPayed === 1
          ? "Payé en totalité"
          : item.isPayed === 0 && item?.restToPay === item?.price
            ? "Payé Partiellement"
            : "Non Payé",
    }));

    // Create the worksheet with custom headers
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Manually insert headers with custom texts
    XLSX.utils.sheet_add_aoa(worksheet, [headers.map((h) => h.text)], {
      origin: "A1",
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "tickets Data");

    const filename_ticket = `tickets_${UtilsFormule.formatDateHours(
      new Date()
    )}.xlsx`;
    XLSX.writeFile(workbook, filename_ticket);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReference(null);
    setNewCreationDate("");
  };
    const handleSaveDate = () => {
      console.log("Saving new date:", `${newCreationDate}`, "for reference:", selectedReference);
      OrderService.updateOrderCreationDate(getCurrentUserId(), selectedReference, newCreationDate)
        .then((response) => {
          toastr.success("Ticket mis à jour avec succès")
          setShowModal(false);
        })
        .catch(() => {
          // setOpenErrorAlert(true);
          setShowModal(false);
          toastr.error("Erreur lors de la mise à jour du ticket");
        });
    };
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Tickets</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={tickets}
          columns={columns}
          onTableChange={handleTableChange}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  />
                </div>
                <div className="ml-auto mr-0">
                  <MyExportCSV {...props.csvProps} />{" "}
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}

      <Dialog
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">Confirmer la Suppression</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Veuillez écrire la référence <strong>{reference}</strong> ci-dessous pour confirmer la suppression. Cette action est irréversible.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="reference-input"
            label="Entrez la Référence"
            type="text"
            fullWidth
            value={enteredReference}
            onChange={(e) => setEnteredReference(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteModal} color="secondary">
            Annuler
          </Button>
          <Button
            onClick={handleDelete}
            color="primary"
            disabled={enteredReference !== reference}
          >
            Confirmer & Supprimer
          </Button>
        </DialogActions>
      </Dialog>
   <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Modifier la Date de Création</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><strong>Référence du ticket:</strong> {selectedReference}</p>
          <Form.Group>
            <Form.Label>Modifier la Date de Création</Form.Label>
            <Form.Control
              type="datetime-local"
              value={newCreationDate}
              onChange={(e) => setNewCreationDate(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Annuler
          </Button>
          <Button variant="primary" onClick={handleSaveDate}>
            Enregistrer
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};
export default DataTableTicketShop;
